import Swiper from "swiper/bundle";
import "swiper/swiper-bundle.css";

export default function initIntroSwiper() {
  const swiper = new Swiper(".intro__slider", {
    direction: "horizontal",
    autoplay: {
      delay: 5000,
    },
    loop: true,
    allowTouchMove: false,

    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
}
